export type { IVirtualElement } from '@fluentui/dom-utilities';
